var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rs-select',_vm._g(_vm._b({attrs:{"label":_vm.label,"items":_vm.options,"hide-details":"auto"}},'rs-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }